import React from "react";
import Navbar from "./components/Navbar";
import TweetInput from "./components/TweetInput";
import Footer from "./components/Footer";
import ImageConfig from "./components/ImageConfig";
import ConfigContextProvider from "./contexts/ConfigContext";
import ImageContextProvider from "./contexts/ImageContext";
import {
	Routes,
	Route,
	Navigate
  } from "react-router-dom";
function App() {
	return (
<Routes>
<Route path='/:url' exact element={
			<>
		<div>
			<Navbar />
			<div className="grid-compo container-fluid">
				<ConfigContextProvider>
					<ImageContextProvider>
						<TweetInput />
						<ImageConfig />
					</ImageContextProvider>
				</ConfigContextProvider>
			</div>
			<Footer />
		</div>
			</>
		  }/>
</Routes>


	);
}

export default App;
